module.exports = __webpack_public_path__ + "img/default_staff_img.76da57ad.jpg";